import {AutocompleteInput,Filter,Loading,useDataProvider} from 'react-admin'
import React from 'react'
import {ActionTitles} from '../Constants'
import {width} from '../Styles'
import { Error404 } from '../errors/Error404'

export const ClientDefaultsAdminFilter = (props) => {
  const dataProvider = useDataProvider();
  const [partnerChoices, setPartnerChoices] = React.useState();
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState();

  React.useEffect(() => {
    dataProvider
      .getClientNameList("admin/client/names")
      .then(({ data }) => {
        setPartnerChoices(data);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  }, [dataProvider]);

  if (loading) return <Loading />;
  if (error) return <Error404 />;

  return (<>
    <Filter {...props}>
      <AutocompleteInput
        id="client-defaults-filter-client"
        source="clientId"
        name="clientId"
        variant="outlined"
        size="small"
        label={ActionTitles.CORPORATE_PARTNER}
        choices={partnerChoices}
        resettable
        alwaysOn
        sx={width.fixed.w300}
      />
    </Filter>
  </>);
}